module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('strong', [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Foreword#fm-1"
    }
  }, [_c('em', [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Preface#fm-2"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Abbre#fm-3"
    }
  }, [_c('em', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#ch-1"
    }
  }, [_c('strong', [_vm._v("THE EPISTLE TO THE COLOSSIANS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01aBib#sec-1"
    }
  }, [_vm._v("BIBLIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01bInt#sec-2"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01bInt#sec2-1"
    }
  }, [_vm._v("THE SIGNIFICANCE OF THE LETTER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01bInt#sec2-2"
    }
  }, [_vm._v("COLOSSAE AND THE ESTABLISHMENT OF CHRISTIANITY THERE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01bInt#sec2-3"
    }
  }, [_vm._v("THE TROUBLE AT COLOSSAE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01bInt#sec3-1"
    }
  }, [_c('em', [_vm._v("Presuppositions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01bInt#sec3-2"
    }
  }, [_c('em', [_vm._v("Gnosticizing Syncretism … ?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01bInt#sec3-3"
    }
  }, [_c('em', [_vm._v("… or Jewish?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01bInt#sec3-4"
    }
  }, [_c('em', [_vm._v("The Colossian Philosophy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01bInt#sec2-4"
    }
  }, [_vm._v("WHO WROTE COLOSSIANS?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01bInt#sec2-5"
    }
  }, [_vm._v("WHERE AND WHEN WAS COLOSSIANS WRITTEN?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01bInt#sec2-6"
    }
  }, [_vm._v("THE STRUCTURE OF COLOSSIANS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-seca"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01cComm#page_43"
    }
  }, [_vm._v("COMMENTARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01cComm#sec2-7"
    }
  }, [_vm._v("ADDRESS AND GREETING (1:1-2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01cComm#sec2-8"
    }
  }, [_vm._v("EXTENDED THANKSGIVING (1:3-23)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01cComm#sec3-5"
    }
  }, [_c('em', [_vm._v("Thanksgiving (1:3-8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01cComm#sec3-6"
    }
  }, [_c('em', [_vm._v("Prayer for the Colossian Recipients (1:9-14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01cComm#sec3-7"
    }
  }, [_c('em', [_vm._v("A Hymn in Praise of Christ (1:15-20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01cComm#sec3-8"
    }
  }, [_c('em', [_vm._v("Reconciliation and Response (1:21-23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01cComm#sec2-9"
    }
  }, [_vm._v("A PERSONAL STATEMENT (1:24–2:5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01cComm#sec3-9"
    }
  }, [_c('em', [_vm._v("Paul’s Commitment to the Gospel (1:24-29)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/009_Chapter01cComm#sec3-10"
    }
  }, [_c('em', [_vm._v("Paul’s Commitment to the Colossians (2:1-5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009b_Chapter01cComm#sec2-10"
    }
  }, [_vm._v("THE THEME OF THE LETTER (2:6–4:6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009b_Chapter01cComm#sec2-11"
    }
  }, [_vm._v("THE THEMATIC STATEMENT (2:6-7)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009b_Chapter01cComm#sec2-12"
    }
  }, [_vm._v("THE CROSS OF CHRIST RENDERS UNNECESSARY ANY FURTHER HUMAN TRADITIONS AND RULES (2:8-23)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009b_Chapter01cComm#sec3-11"
    }
  }, [_c('em', [_vm._v("The Scope of Christ’s Accomplishments on the Cross (2:8-15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009b_Chapter01cComm#sec3-12"
    }
  }, [_c('em', [_vm._v("Beware of Claims That There Are More Important Practices and Experiences (2:16-19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009b_Chapter01cComm#sec3-13"
    }
  }, [_c('em', [_vm._v("Life in Christ Does Not Depend on Observance of Jewish Practices (2:20-23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009b_Chapter01cComm#sec2-13"
    }
  }, [_vm._v("THE PATTERN OF LIVING THAT FOLLOWS FROM THE CROSS (3:1–4:6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009b_Chapter01cComm#sec3-14"
    }
  }, [_c('em', [_vm._v("The Perspective from Which the Christian Life Should Be Lived (3:1-4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009c_Chapter01cComm#sec3-15"
    }
  }, [_c('em', [_vm._v("General Guidelines and Practical Exhortations (3:5-17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009c_Chapter01cComm#sec3-16"
    }
  }, [_c('em', [_vm._v("Household Rules (3:18–4:1)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009c_Chapter01cComm#sec3-17"
    }
  }, [_c('em', [_vm._v("Concluding Exhortations (4:2-6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009c_Chapter01cComm#sec2-14"
    }
  }, [_vm._v("CONCLUSION (4:7-18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009c_Chapter01cComm#sec3-18"
    }
  }, [_c('em', [_vm._v("Maintaining Communication (4:7-9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009c_Chapter01cComm#sec3-19"
    }
  }, [_c('em', [_vm._v("Greetings (4:10-17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009c_Chapter01cComm#sec3-20"
    }
  }, [_c('em', [_vm._v("A Final, Personal Greeting (4:18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THE EPISTLE TO PHILEMON")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02aBib#sec-3"
    }
  }, [_vm._v("BIBLIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02bInt#sec-4"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02bInt#sec2-15"
    }
  }, [_vm._v("THE AUTHOR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02bInt#sec2-16"
    }
  }, [_vm._v("THE RECIPIENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02bInt#sec2-17"
    }
  }, [_vm._v("THE OCCASION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02bInt#sec2-18"
    }
  }, [_vm._v("THE PLACE OF WRITING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02bInt#sec2-19"
    }
  }, [_vm._v("THE STRUCTURE OF THE LETTER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-seca"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02cComm#page_310"
    }
  }, [_vm._v("COMMENTARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02cComm#sec2-20"
    }
  }, [_vm._v("ADDRESS AND GREETING (1-3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02cComm#sec2-21"
    }
  }, [_vm._v("THANKSGIVING AND PRAYER (4-7)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02cComm#sec2-22"
    }
  }, [_vm._v("APPEAL TO PHILEMON (8-20)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02cComm#sec2-23"
    }
  }, [_vm._v("IN CONCLUSION (21-25)")]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4290e24c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0